import { mapMutations, mapState, mapGetters } from 'vuex';
import { tsNow } from '@/utils/timeSync';

export default {
  computed: {
    ...mapState(['chatboxEnd', 'lessonStart']),
    ...mapGetters(['isLessonOngoing']),
  },
  methods: {
    ...mapMutations('lesson', ['setLessonBeyondChatPeriod']),
    isEnableChatbox() {
      if (!this.isLessonOngoing) {
        return;
      }
      const now = tsNow();
      const chatboxEnd = this.chatboxEnd * 1000;
      if ((now >= this.lessonStart * 1000) && (chatboxEnd > now)) {
        return true;
      }

      if (now > chatboxEnd) {
        this.setLessonBeyondChatPeriod(true);
      }

      return false;
    }
  }
}
